export const Starfield = () => {
  return (
    <div className="starfield" aria-hidden="true">
      <div className="star-layer star-layer--sm" />
      <div className="star-layer star-layer--md star-twinkle" />
    </div>
  );
};
